module.exports = __webpack_public_path__ + "static/media/starting-photo-2.8f60c9d7.png";